<script>
export default {
  name: 'nx-default-toolbar-after-spacer-items',
  functional: true,
  render() {
    return '';
  },
};
</script>
